import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { Car, Loader2, AlertCircle } from 'lucide-react';
export function DriverLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const {
        error: authError
      } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      if (authError) throw authError;
      navigate('/driver/app');
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-[#0B0B0B] flex flex-col items-center justify-center p-6 text-white" data-id="element-7071" data-mp="1scs8bg4e26mq">
      <div className="w-full max-w-sm space-y-8" data-id="element-7072" data-mp="35c5jetyhbndf">
        <div className="text-center" data-id="element-7073" data-mp="35cxfe5vznn48">
          <div className="w-16 h-16 bg-[#006847] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#006847]/20" data-id="element-7074" data-mp="359t3emca7n30">
            <Car className="w-8 h-8 text-white" data-id="element-7075" data-mp="3f277vmuqv7sv" />
          </div>
          <h1 className="text-3xl font-black tracking-tight" data-id="element-7076" data-mp="3f3s0h6xi0go3">NOIZA Driver</h1>
          <p className="text-white/50 mt-2 text-sm" data-id="element-7077" data-mp="3a9xjib9a2fsp">
            Inicia sesión para empezar a recibir viajes.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4" data-id="element-7078" data-mp="3j3sq7nq1seag">
          <div data-id="element-7079" data-mp="3j3ak7zdl2lpc">
            <label className="block text-xs font-bold text-white/50 uppercase tracking-wider mb-2" data-id="element-7080" data-mp="3j5wrrz0h517k">
              Correo electrónico
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-white/20 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] transition-all" placeholder="conductor@noiza.com" required data-id="element-7081" data-mp="3t31j0d96fmv8" />
          </div>

          <div data-id="element-7082" data-mp="2xcj1qxhk82jm">
            <label className="block text-xs font-bold text-white/50 uppercase tracking-wider mb-2" data-id="element-7083" data-mp="2xbzucapjcwju">
              Contraseña
            </label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-white/20 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847] transition-all" placeholder="••••••••" required data-id="element-7084" data-mp="32d6ylzsgzdlr" />
          </div>

          {error && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-xl flex items-start gap-3 text-red-400 text-sm" data-id="element-7085" data-mp="3q29htc2r5eid">
              <AlertCircle className="w-5 h-5 shrink-0" data-id="element-7086" data-mp="3v0jdrowawj51" />
              <p data-id="element-7087" data-mp="1jd7rzcxipxf8">{error}</p>
            </div>}

          <button type="submit" disabled={loading || !email || !password} className="w-full bg-[#006847] hover:bg-[#005a3d] disabled:bg-white/5 disabled:text-white/30 text-white font-bold py-4 rounded-xl transition-all flex items-center justify-center gap-2 mt-4" data-id="element-7088" data-mp="1jal9ii939xi8">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-7089" data-mp="223p6odlimshl" /> : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>;
}